module.exports = __webpack_public_path__ + "img/Wp_2029.164e7ea4.png";